import Form from '../../common/form';
import Joi from 'joi';

import { func } from 'prop-types';
import { IMAGE_LIMITS } from '../../../utils/constants';
import { getResultOptions } from '../../../utils/data';

class ETInspectionItemForm extends Form {
	state = {
		data: {
			description: '',
			result: '',
			images: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		description: Joi.string().min(3).required().label('Description'),
		result: Joi.string().required().label('Result'),
		images: Joi.array().min(1).max(IMAGE_LIMITS.GENERAL_PHOTOS).required().label('Images'),
	};

	static propTypes = {
		onAdd: func,
	};

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);
		
		this.setState({ 
			data: {
				description: '',
				result: '',
				images: [],
			} 
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							name: 'description',
							type: 'text',
							label: 'Description',
							placeholder: 'Enter Description',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'result',
							label: 'Result',
							placeholder: 'Select Result',
							options: getResultOptions(),
						})}
					</div>

					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.props.photoNumbers,
							name: 'images',
							placeholder: 'Select Photo Number',
							label: 'Photo Number',
							isMulti: true,
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Add Item')}
				</div>
			</form>
		);
	}
}

export default ETInspectionItemForm;
